import { createBrowserRouter } from "react-router-dom";
import { AppLayout } from "@/app/layouts";
import { ProtectedRoute } from "@/app/routes/protected";
import { NotFoundPage } from "@/components/common";
import { PATHS } from "@/lib/router";
import { authRoutes } from "@/features/auth";
import { dashboardRoutes } from "@/features/dashboard";
import { userManagementRoutes } from "@/features/user-management";
import { companyRoutes } from "@/features/company";
import { organizationRoutes } from "@/features/organization";
import { onboardingRoutes } from "@/features/onboarding";
import { moreSolutionsRoutes } from "@/features/more-solutions";
import { activityLogRoutes } from "@/features/activity-log";
import { settingsRoutes } from "@/features/settings";
import { surveysRoutes, surveysPublicRoutes } from "@/features/surveys";
import { notificationsRoutes } from "@/features/notifications";
import { esgRoutes } from "@/features/esg";

// Compose all feature routes
const routes = [
  ...authRoutes,
  ...surveysPublicRoutes,
  {
    element: (
      <ProtectedRoute>
        <AppLayout />
      </ProtectedRoute>
    ),
    children: [
      ...dashboardRoutes,
      ...userManagementRoutes,
      ...companyRoutes,
      ...organizationRoutes,
      ...onboardingRoutes,
      ...moreSolutionsRoutes,
      ...settingsRoutes,
      ...activityLogRoutes,
      ...notificationsRoutes,
      ...surveysRoutes,
      ...esgRoutes,
    ],
  },
  {
    path: PATHS.NOT_FOUND,
    element: <NotFoundPage />,
  },
];

// Create router instance
export const router = createBrowserRouter(routes);
